export default [
  {
    section: "Fachada e Entrada",
    photos: [
      {
        path: "/casaRegina/fachada-1.jpeg",
        title: "Vista frontal da residência"
      },
      {
        path: "/casaRegina/fachada-2.jpeg",
        title: "Fachada principal"
      },
      {
        path: "/casaRegina/fachada-3.jpeg",
        title: "Vista lateral da fachada"
      },
      {
        path: "/casaRegina/fachada-4.jpeg",
        title: "Detalhes arquitetônicos da fachada"
      },
      {
        path: "/casaRegina/fachada-5.jpeg",
        title: "Vista noturna da fachada"
      },
      {
        path: "/casaRegina/fachada-6.jpeg",
        title: "Entrada principal"
      },
      {
        path: "/casaRegina/fachada-7.jpeg",
        title: "Vista panorâmica da fachada"
      },
      {
        path: "/casaRegina/entrada-1.jpeg",
        title: "Hall de entrada"
      },
      {
        path: "/casaRegina/entrada-2.jpeg",
        title: "Detalhes do hall"
      },
      {
        path: "/casaRegina/entrada-3.jpeg",
        title: "Acesso principal"
      },
      {
        path: "/casaRegina/entrada-4.jpeg",
        title: "Vista do hall de entrada"
      },
      {
        path: "/casaRegina/entrada-5.jpeg",
        title: "Porta principal"
      }
    ]
  },
  {
    section: "Garagem e Acesso",
    photos: [
      {
        path: "/casaRegina/garagem-1.jpeg",
        title: "Garagem principal"
      },
      {
        path: "/casaRegina/garagem-2.jpeg",
        title: "Vagas cobertas"
      },
      {
        path: "/casaRegina/garagem-3.jpeg",
        title: "Acesso à garagem"
      },
      {
        path: "/casaRegina/garagem-4.jpeg",
        title: "Área de estacionamento"
      },
      {
        path: "/casaRegina/garagem-5.jpeg",
        title: "Vista da garagem"
      },
      {
        path: "/casaRegina/garagem-6.jpeg",
        title: "Espaço adicional"
      },
      {
        path: "/casaRegina/garagem-7.jpeg",
        title: "Área de manobra"
      },
      {
        path: "/casaRegina/garagem-8.jpeg",
        title: "Portão automático"
      },
      {
        path: "/casaRegina/garagem-9.jpeg",
        title: "Iluminação"
      },
      {
        path: "/casaRegina/garagem-10.jpeg",
        title: "Acesso lateral"
      },
      {
        path: "/casaRegina/garagem-11.jpeg",
        title: "Área de serviço"
      },
      {
        path: "/casaRegina/garagem-12.jpeg",
        title: "Depósito"
      },
      {
        path: "/casaRegina/garagem-13.jpeg",
        title: "Área técnica"
      },
      {
        path: "/casaRegina/garagem-14.jpeg",
        title: "Acesso secundário"
      },
      {
        path: "/casaRegina/garagem-15.jpeg",
        title: "Vista externa"
      },
      {
        path: "/casaRegina/garagem-16.jpeg",
        title: "Área coberta"
      },
      {
        path: "/casaRegina/acesso-1.jpeg",
        title: "Acesso lateral"
      },
      {
        path: "/casaRegina/acesso-2.jpeg",
        title: "Entrada de serviço"
      },
      {
        path: "/casaRegina/acesso-3.jpeg",
        title: "Corredor de acesso"
      }
    ]
  },
  {
    section: "Área Social",
    photos: [
      {
        path: "/casaRegina/sala-1.jpeg",
        title: "Sala de estar principal"
      },
      {
        path: "/casaRegina/sala-2.jpeg",
        title: "Sala de estar - vista alternativa"
      },
      {
        path: "/casaRegina/sala-3.jpeg",
        title: "Área de convivência"
      },
      {
        path: "/casaRegina/sala-4.jpeg",
        title: "Sala de estar integrada"
      },
      {
        path: "/casaRegina/sala-5.jpeg",
        title: "Ambiente social"
      },
      {
        path: "/casaRegina/sala-6.jpeg",
        title: "Detalhes da sala"
      },
      {
        path: "/casaRegina/sala-7.jpeg",
        title: "Vista ampla da sala"
      },
      {
        path: "/casaRegina/sala-8.jpeg",
        title: "Área de convívio"
      },
      {
        path: "/casaRegina/sala-9.jpeg",
        title: "Sala de estar e jantar"
      }
    ]
  },
  {
    section: "Cozinha",
    photos: [
      {
        path: "/casaRegina/cozinha-1.jpeg",
        title: "Cozinha planejada"
      },
      {
        path: "/casaRegina/cozinha-2.jpeg",
        title: "Bancada e armários"
      },
      {
        path: "/casaRegina/cozinha-3.jpeg",
        title: "Área de preparo"
      },
      {
        path: "/casaRegina/cozinha-4.jpeg",
        title: "Vista geral da cozinha"
      },
      {
        path: "/casaRegina/cozinha-5.jpeg",
        title: "Detalhes dos armários"
      },
      {
        path: "/casaRegina/cozinha-6.jpeg",
        title: "Área gourmet"
      },
      {
        path: "/casaRegina/cozinha-7.jpeg",
        title: "Eletrodomésticos"
      },
      {
        path: "/casaRegina/cozinha-8.jpeg",
        title: "Bancada de trabalho"
      },
      {
        path: "/casaRegina/cozinha-9.jpeg",
        title: "Vista lateral da cozinha"
      },
      {
        path: "/casaRegina/cozinha-10.jpeg",
        title: "Área de refeições"
      },
      {
        path: "/casaRegina/cozinha-11.jpeg",
        title: "Detalhes da bancada"
      }
    ]
  },
  {
    section: "Suíte Master",
    photos: [
      {
        path: "/casaRegina/suite-1.jpeg",
        title: "Suíte principal"
      },
      {
        path: "/casaRegina/suite-2.jpeg",
        title: "Área de descanso"
      },
      {
        path: "/casaRegina/suite-3.jpeg",
        title: "Vista do quarto"
      },
      {
        path: "/casaRegina/suite-4.jpeg",
        title: "Closet"
      },
      {
        path: "/casaRegina/suite-5.jpeg",
        title: "Detalhes do quarto"
      },
      {
        path: "/casaRegina/suite-6.jpeg",
        title: "Área de vestir"
      },
      {
        path: "/casaRegina/suite-7.jpeg",
        title: "Banheiro da suíte"
      },
      {
        path: "/casaRegina/suite-8.jpeg",
        title: "Vista ampla da suíte"
      },
      {
        path: "/casaRegina/suite-9.jpeg",
        title: "Detalhes do closet"
      },
      {
        path: "/casaRegina/suite-10.jpeg",
        title: "Banheiro completo"
      }
    ]
  },
  {
    section: "Demais Dormitórios",
    photos: [
      {
        path: "/casaRegina/quartos-1.jpeg",
        title: "Segundo dormitório"
      },
      {
        path: "/casaRegina/quartos-2.jpeg",
        title: "Terceiro dormitório"
      },
      {
        path: "/casaRegina/quartos-3.jpeg",
        title: "Quarto dormitório"
      },
      {
        path: "/casaRegina/quartos-4.jpeg",
        title: "Vista dos quartos"
      },
      {
        path: "/casaRegina/quartos-5.jpeg",
        title: "Detalhes do quarto"
      },
      {
        path: "/casaRegina/quartos-6.jpeg",
        title: "Armários planejados"
      },
      {
        path: "/casaRegina/quartos-7.jpeg",
        title: "Área de estudos"
      },
      {
        path: "/casaRegina/quartos-8.jpeg",
        title: "Vista alternativa"
      },
      {
        path: "/casaRegina/quartos-9.jpeg",
        title: "Detalhes da iluminação"
      },
      {
        path: "/casaRegina/quartos-10.jpeg",
        title: "Acabamentos"
      },
      {
        path: "/casaRegina/quartos-11.jpeg",
        title: "Vista da janela"
      },
      {
        path: "/casaRegina/quartos-12.jpeg",
        title: "Espaço de trabalho"
      },
      {
        path: "/casaRegina/quartos-13.jpeg",
        title: "Detalhes do mobiliário"
      },
      {
        path: "/casaRegina/quartos-14.jpeg",
        title: "Área de descanso"
      },
      {
        path: "/casaRegina/quartos-15.jpeg",
        title: "Vista panorâmica"
      },
      {
        path: "/casaRegina/quartos-16.jpeg",
        title: "Detalhes finais"
      }
    ]
  },
  {
    section: "Quarto Adicional",
    photos: [
      {
        path: "/casaRegina/quarto-baixo-1.jpeg",
        title: "Quarto térreo - vista principal"
      },
      {
        path: "/casaRegina/quarto-baixo-2.jpeg",
        title: "Área de descanso"
      },
      {
        path: "/casaRegina/quarto-baixo-3.jpeg",
        title: "Armários planejados"
      },
      {
        path: "/casaRegina/quarto-baixo-4.jpeg",
        title: "Vista da janela"
      },
      {
        path: "/casaRegina/quarto-baixo-5.jpeg",
        title: "Detalhes do quarto"
      },
      {
        path: "/casaRegina/quarto-baixo-6.jpeg",
        title: "Vista completa"
      }
    ]
  },
  {
    section: "Banheiros e Lavabo",
    photos: [
      {
        path: "/casaRegina/banheiro1.jpeg",
        title: "Banheiro social 1"
      },
      {
        path: "/casaRegina/banheiro2.jpeg",
        title: "Banheiro social 2"
      },
      {
        path: "/casaRegina/banheiro3.jpeg",
        title: "Banheiro social 3"
      },
      {
        path: "/casaRegina/lavabo-1.jpeg",
        title: "Lavabo social"
      },
      {
        path: "/casaRegina/lavabo-2.jpeg",
        title: "Detalhes do lavabo"
      }
    ]
  },
  {
    section: "Varanda",
    photos: [
      {
        path: "/casaRegina/varanda-1.jpeg",
        title: "Varanda gourmet"
      },
      {
        path: "/casaRegina/varanda-2.jpeg",
        title: "Área de churrasqueira"
      },
      {
        path: "/casaRegina/varanda-3.jpeg",
        title: "Espaço de lazer"
      },
      {
        path: "/casaRegina/varanda-4.jpeg",
        title: "Vista da varanda"
      },
      {
        path: "/casaRegina/varanda-5.jpeg",
        title: "Área de convivência externa"
      },
      {
        path: "/casaRegina/varanda-6.jpeg",
        title: "Detalhes da varanda"
      },
      {
        path: "/casaRegina/varanda-7.jpeg",
        title: "Área de refeições externa"
      },
      {
        path: "/casaRegina/varanda-8.jpeg",
        title: "Vista panorâmica"
      },
      {
        path: "/casaRegina/varanda-9.jpeg",
        title: "Área de lazer completa"
      }
    ]
  },
  {
    section: "Circulação",
    photos: [
      {
        path: "/casaRegina/corredor-1.jpeg",
        title: "Corredor principal"
      },
      {
        path: "/casaRegina/corredor-2.jpeg",
        title: "Área de circulação"
      },
      {
        path: "/casaRegina/corredor-3.jpeg",
        title: "Escada"
      },
      {
        path: "/casaRegina/corredor-4.jpeg",
        title: "Hall de distribuição"
      }
    ]
  }
];
